export default __webpack_public_path__ + "static/media/ye.822b8bf2.svg";